import React, {useEffect, useState} from 'react'
import {Audio, Loader, Slider, Tooltip} from '@kaleyra/emmy'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import Styles from './soundManager.module.scss'
import {Tags} from '../../../store/models/soundManager.interface'
import { isEmpty, toString } from 'lodash'
import moment from 'moment'

interface SoundManager {
    title?: string;
    id?: number;
    category?: string|string[];
    duration_format?: string;
    duration?: number;
    created_at?: string;
    expires_in?: string;
    file_path?: string;
    tags?: Tags
}
export type MapStateToPropsType = {
    params: any;
    soundList:any,
    inProgress:boolean
};

export type MapDispatchToPropsType = {
    closeModal: () => void;
    loadSoundData : (filter:any) => void,
};

type Props = MapStateToPropsType & MapDispatchToPropsType

const ViewSound = (
    {
        params,
        soundList,
        closeModal,
        loadSoundData,
        inProgress
    }: Props) => {

    const { id } = params.viewData
    const [soundData,setSoundData] = useState<SoundManager>({});
    const { t } = useTranslation();

    useEffect(()=>{
        loadSoundData({id:id});
    },[]);

    useEffect(()=>{
        if(!isEmpty(soundList)){
            setSoundData(soundList[0]);
        }
    },[soundList]);
    const { title="", category="", created_at, duration_format, tags, file_path="", duration } = soundData;
    const soundTags = isEmpty(tags) ? '-' : toString(Object.values(tags||{}))
    return (
            <Slider
                visibility={true}
                title={t('BLD00566')}
                onClose={closeModal}
                containerId="root-modal"
            >
                {inProgress && <Loader/>}
                {!inProgress && <div className={Styles.viewSound}>
                    <div className={Styles.audio}>
                        <div>
                            <Audio
                                filePath={file_path}
                                soundDuration={duration}
                                soundId={id}
                                key={id}
                            />
                        </div>
                        <span className={Styles.audioTitle}>
                    <span className={Styles.ntitle}>{t('fileName')}</span>
                        <span className={Styles.ndesc} >{title}</span>
                </span>
                    </div>
                    <div className={Styles.audioDesc}>
                        <span className={cn(Styles.ntitle, Styles.key)}>{t('mainType')}</span>
                        <span className={cn(Styles.ndesc, Styles.val)}>{category}</span>
                    </div>
                    <div className={Styles.audioDesc}>
                        <span className={cn(Styles.ntitle, Styles.key)}>{t('camCreatedOn')}</span>
                        <span className={cn(Styles.ndesc, Styles.val)}>{moment(created_at).format("DD MMM YYYY")}</span>
                    </div>
                    <div className={Styles.audioDesc}>
                        <span className={cn(Styles.ntitle, Styles.key)}>{t('mainDuration')}</span>
                        <span className={cn(Styles.ndesc, Styles.val)}>{duration_format}</span>
                    </div>
                    <div className={Styles.audioDesc}>
                        <span className={cn(Styles.ntitle, Styles.key)}>{t('mainTags')}</span>
                        <Tooltip title={soundTags}>
                            <span className={cn(Styles.ndesc, Styles.val)}>{soundTags}</span>
                        </Tooltip>
                    </div>
                </div>}
            </Slider>
         )
}

export default ViewSound
